module.exports = __webpack_public_path__ + "static/media/pinch.bf2cd10f.png";